export const ADDON_LIST = 'ADDON_LIST';
export const ADDON_LIST_SUCCESSFUL = 'ADDON_LIST_SUCCESSFUL';
export const ADDON_API_ERROR ="ADDON_API_ERROR";